type Route = {
  path: string,
  redirect?: string,
  component: Element,
  children?: Route[]
}

export type Register = {
  routes: Route[],
  beforeMounted?: () => Promise<any>,
  afterUnmounted?: () => Promise<any>,
}

/**
 * 1、require 是同步加载模块的，并且 require 可以是运行时加载，这就是为什么能在代码片段中写 require 的原因
 * 2、reqiure().default 只适用于 es6 export default 的模块，这时候 require() 才需要用 .default 取值
 * 3、es6 export 的模块（非 export default），只需要 require() 就行，取得的值就是一个对象
 */
export function loadableModule (path: string): any | null | undefined {
  try {
    /**
     * 合成路径 `app/${value}` app/ 前缀不能省略，否则 reqiure 是无法识别动态路径的
     * 不管是 import(`app/${path}`) 还是 require(`app/${path}`)
     * 当使用动态路径时候，必须有一部分的静态路径
     */
    /**
     * 注意：这边的 alias 路径 'app/' 已经在编译阶段就配置完成，
     * 通过 npm 的启动参数配置 alias 路径 'app/' 指向具体的子模块，
     * 比如 npm start --app=rtm ，则 'app/' 路径指向 'src/app/rtm'，
     * 如此一来就可以通过 npm 的启动参数，来确认具体运行的子模块
     * 具体可查看 webpack 配置文件 config\modules.js
     */
    const module = require(`app/${path}`)
    const isGetDefault = Object.prototype.hasOwnProperty.call(module, 'default')
    return isGetDefault ? module.default : module
  } catch (e) {
    return undefined
  }
}

const register = (): Promise<Register> => {
  return new Promise((resolve, reject) => {
    const config = loadableModule('register.ts')
    if (config instanceof Function) {
      resolve(config())
    } else {
      reject(new Error('Cannot find register.ts'))
    }
  })
}

export default register